import { ICoreContext } from '@msdyn365-commerce/core';
import * as React from 'react';
import ServerSideRedirect from '../../../components/server-side-redirect/server-side-redirect';
import { isInHomePage } from '../../../shared/functions/msdyn-helpers';
import { areUrlsEqual } from '../../../shared/functions/url-helpers';
import {
    buildGenderUrl,
    getGenderCookie,
    getGenderUrlsForLocale
} from '../../../shared/services/gender-cookie-service/gender-cookie-service';

export default function GenderRedirect({
    context,
    enableRedirectOnCookie = false
}: {
    context: ICoreContext;
    enableRedirectOnCookie?: boolean;
}) {
    const { request } = context;

    if (!enableRedirectOnCookie || !isInHomePage(context) || getGenderCookie(request) !== 'male') {
        return null;
    }

    const homeUrl: string = request.app.routes.home.destinationUrl;
    if (!areUrlsEqual(homeUrl, request.url.requestUrl.pathname)) {
        return null;
    }

    const genderUrls = getGenderUrlsForLocale(request.app.config.localeGenderUrls, request.locale);
    if (!genderUrls?.male) {
        return null;
    }

    return <ServerSideRedirect redirectUrl={buildGenderUrl(homeUrl, genderUrls.male)} />;
}
